<template>
  <div class="dsfa-sc-loading">
    <div class="dsfa-sc-loading-container">
      <img class="dsfa-sc-loading-img" src="~_statistics-cloud/assets/styles/img/loading/loading-img.svg" alt="" />
      <img class="dsfa-sc-loading-name" src="~_statistics-cloud/assets/styles/img/loading/loading-name.svg" alt="" />
      <div class="dsfa-sc-loading-text">正在努力加载中，请稍等...</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DsfSCLoading",
  data() {
    return {};
  },
  components: {},
  created() {},
  methods: {},
};
</script>
